import { collection, getDocs, query, where } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { validateEmail } from '@/utils/emailUtils';

export async function validateEvaluatorEmail(userId: string, email: string): Promise<{
  isValid: boolean;
  message?: string;
}> {
  try {
    if (!validateEmail(email)) {
      return {
        isValid: false,
        message: 'Invalid email format'
      };
    }

    const evaluatorsRef = collection(db, collections.evaluators);
    const q = query(evaluatorsRef, 
      where('userId', '==', userId),
      where('email', '==', email.toLowerCase().trim())
    );
    const snapshot = await getDocs(q);
    
    return {
      isValid: snapshot.empty,
      message: snapshot.empty ? undefined : 'An evaluator with this email already exists'
    };
  } catch (error) {
    console.error('Error validating evaluator email:', error);
    return {
      isValid: false,
      message: 'Failed to validate email'
    };
  }
}

export async function validateContextEligibility(evaluatorId: string, userId: string): Promise<{
  eligible: boolean;
  message?: string;
}> {
  try {
    const evaluatorsRef = collection(db, collections.evaluators);
    const q = query(evaluatorsRef, where('userId', '==', userId));
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      return {
        eligible: false,
        message: 'Evaluator not found'
      };
    }

    const evaluator = snapshot.docs[0].data();
    if (evaluator.contextualized) {
      return {
        eligible: false,
        message: 'Context has already been provided for this evaluator'
      };
    }

    if (evaluator.evaluationCompleted) {
      return {
        eligible: false,
        message: 'Cannot provide context after evaluation is completed'
      };
    }

    return { eligible: true };
  } catch (error) {
    console.error('Error validating context eligibility:', error);
    throw new Error('Unable to validate context eligibility');
  }
}